import FilterSetHandler from "@/ts/components/FilterSetHandler";
import EtRangeSlider from "@/ts/components/EtRangeSlider";

export default function(vwtype: string, vwname: string): void {
    new EtRangeSlider();
    new FilterSetHandler();
}